// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "assets/styling-" + {"42832": "5924e9347b531c47","96027": "41e5536e9f227c14",}[chunkId] + ".css"
}